import logo from './data/logoch.png';
import logoa from './data/logoa.png';
import { useNavigate, useParams } from "react-router-dom";
import { HomeIcon } from 'lucide-react';
import { LockIcon } from 'lucide-react';
export default function Mfooter() {

const navigate = useNavigate();
return (
    <div align= "center">
    <table  border="0">
        <tr>
            <td>
                
               {/* <button id="homebutton" className="custom-button" onClick={() =>  navigate("/")}><HomeIcon className="mr-3" /><br/>Home Page</button> */}
            </td>
            <td>
                <button id="areaRiservata" className="custom-button" onClick={() =>  navigate("/landingpage")}><LockIcon className="mr-3" /> <br/>Home</button>
                
            </td>
    </tr>

    </table>
        <table width="100%" border="0">
            <tr>
                
                <td align="right">
                    <h3>Spoke 6 – History, Conservation and Restoration of Cultural Heritage</h3>
                </td>
                <td align="right">
                    <img  width="50%" alt ="logo" className="App-logo " src={logo}></img><p><small></small></p>
                </td>
            </tr>
        </table>
    </div>
)
}